import { render, staticRenderFns } from "./RiskPage.vue?vue&type=template&id=58ba3ee4"
import script from "./RiskPage.vue?vue&type=script&lang=js"
export * from "./RiskPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports